// Shared form components for Budget forms
// This file centralizes reusable form renderers to avoid duplication

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import lodash from 'lodash';
import Picker from 'rsuite/DatePicker';

export const renderFieldForm = ({
  input, placeholder, type, isDisabled, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap">
    <input {...input} placeholder={placeholder} type={type} disabled={isDisabled} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderFieldForm.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  isDisabled: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderFieldForm.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
  isDisabled: false,
};

export const renderTextArea = ({ input, meta: { touched, error } }) => (
  <div style={{ width: '100%' }}>
    <label htmlFor="account_settings_form" style={{ width: '100%' }}>
      <div style={{ width: '100%' }}>
        <textarea
          {...input}
          id="account_settings_form"
          rows="10"
          style={{
            width: '100%',
          }}
        />
        {touched && error && <span className="form__form-group-error">{error}</span>}
      </div>
    </label>
  </div>
);

renderTextArea.propTypes = {
  input: PropTypes.shape().isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

export const RenderDatePicker = ({
  input, handleDateChange, meta: { touched, error },
}) => {
  const [pickerId] = useState(lodash.uniqueId('date-picker-'));
  const theme = useSelector(store => store.theme);
  const pickerClasses = classNames(theme.className, theme.className.endsWith('light') ? 'rs-theme-light' : 'rs-theme-dark');

  // Parse date string as local date to avoid timezone offset issues
  const parseLocalDate = (dateValue) => {
    if (!dateValue) return null;

    // If it's already a Date object, return it
    if (dateValue instanceof Date) return dateValue;

    // If it's a moment object, convert to Date
    // eslint-disable-next-line no-underscore-dangle
    if (dateValue._isAMomentObject) return dateValue.toDate();

    // Parse string date in local timezone to avoid UTC conversion issues
    // This prevents "2025-08-01" from being interpreted as UTC midnight
    // which would display as the previous day in timezones behind UTC
    const dateStr = String(dateValue);
    if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const [year, month, day] = dateStr.split('-').map(Number);
      return new Date(year, month - 1, day);
    }

    return new Date(dateValue);
  };

  return (
    <div id={pickerId} style={{ position: 'absolute' }} className={pickerClasses}>
      <Picker
        value={parseLocalDate(input.value)}
        onChange={handleDateChange}
        container={document.getElementById(pickerId)}
        format="yyyy-MM-dd"
        oneTap
      />
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );
};

RenderDatePicker.propTypes = {
  input: PropTypes.shape().isRequired,
  handleDateChange: PropTypes.func.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

RenderDatePicker.defaultProps = {
  meta: {
    touched: false,
    error: null,
  },
};
